import { MrbBaseRouteStore } from "mrb/core";
import {
    NakiNigunArtistService,
    NakiNigunAlbumService,
    EpisodeSortTypeCacheService,
    MediaVaultStreamService,
    NakiNigunArtistFileStreamService,
    NakiNigunAlbumFileStreamService,
    GenreLookupService,
    ProducerService,
} from "common/services";
import moment from "moment";

class NakiNigunArtistEditRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(NakiNigunArtistService);
        this.nakiNigunAlbumService = rootStore.createApplicationService(NakiNigunAlbumService);
        this.episodeSortTypeService = new EpisodeSortTypeCacheService(this.rootStore);
        this.mediaVaultStreamService = new MediaVaultStreamService(
            this.rootStore.apiClient,
            this.rootStore.application.baasic
        );
        this.nakiNigunArtistFileStreamService = this.rootStore.createApplicationService(
            NakiNigunArtistFileStreamService
        );
        this.nakiNigunAlbumFileStreamService = this.rootStore.createApplicationService(NakiNigunAlbumFileStreamService);
        this.genreLookupService = this.rootStore.createApplicationService(GenreLookupService);
        this.producerService = this.rootStore.createApplicationService(ProducerService);
    }

    async getNakiNigunArtist(id) {
        const response = await this.service.get(id, {
            embed: "albums,albums.albumFeed,albums.genres,albums.producers,albums.producers.producer",
        });
        return response.data;
    }

    async createNakiNigunArtist(data) {
        const response = await this.service.create(data);
        return response.data;
    }

    async updateNakiNigunArtist(data) {
        const response = await this.service.update(data);
        return response.data;
    }

    getEpisodeSortTypes() {
        return this.episodeSortTypeService.getItems();
    }

    getMediaVaultFileUrl(id) {
        return this.mediaVaultStreamService.mediaVaultModule.streams.routeDefinition.get(id);
    }

    async uploadImageFile(file) {
        const now = moment();
        const [name, extension] = file.name.split(".");
        const path = `${name}_${now.year()}-${now.month()}-${now.date()}-${now.hour()}-${now.minute()}-${now.second()}.${extension}`;
        const response = await this.mediaVaultStreamService.create(
            {
                path: path,
                fileName: file.name,
            },
            file
        );
        return response.data;
    }

    getNakiNigunArtistCoverImageUrl(coverImageId) {
        return this.nakiNigunArtistFileStreamService.routeService.get(coverImageId);
    }

    getNakiNigunAlbumCoverImageUrl(coverImageId) {
        return this.nakiNigunAlbumFileStreamService.routeService.get(coverImageId);
    }

    async findGenres(searchPhrase) {
        const response = await this.genreLookupService.find(searchPhrase);
        return response.data;
    }

    async findProducers(searchPhrase) {
        const response = await this.producerService.find(searchPhrase);
        return response.data;
    }

    async createProducer(resource) {
        const response = await this.producerService.create(resource);
        return response.data;
    }

    async createGenre(resource) {
        const response = await this.genreLookupService.create(resource);
        return response.data;
    }

    async updateAlbumActiveStatus(id, isActive) {
        const response = await this.nakiNigunAlbumService.updateActiveStatus(id, isActive);
        return response.data;
    }

    async updateAlbumScheduledReleaseAt(id, scheduledReleaseAt) {
        const response = await this.nakiNigunAlbumService.updateScheduledReleaseAt(id, scheduledReleaseAt);
        return response.data;
    }
}

export default NakiNigunArtistEditRouteStore;
